import React from 'react';

export default function YearFilter({ years, yearFrom, yearTo, onChange }) {
  const toggleYear = (year) => {
    // Simple toggle: if clicking the same year that's both from and to, clear it
    if (yearFrom === year && yearTo === year) {
      onChange('yearFrom', null);
      onChange('yearTo', null);
    } else if (yearFrom === null && yearTo === null) {
      onChange('yearFrom', year);
      onChange('yearTo', year);
    } else {
      // Set range
      const allSelected = years.map(y => y.year).filter(y => {
        if (yearFrom && yearTo) return y >= yearFrom && y <= yearTo;
        return false;
      });
      const isSelected = allSelected.includes(year);
      if (isSelected && allSelected.length === 1) {
        onChange('yearFrom', null);
        onChange('yearTo', null);
      } else if (isSelected) {
        // Deselect this year — shrink range
        if (year === yearFrom) onChange('yearFrom', yearFrom + 1);
        else if (year === yearTo) onChange('yearTo', yearTo - 1);
      } else {
        // Expand range to include this year
        const newFrom = yearFrom ? Math.min(yearFrom, year) : year;
        const newTo = yearTo ? Math.max(yearTo, year) : year;
        onChange('yearFrom', newFrom);
        onChange('yearTo', newTo);
      }
    }
  };

  const isYearSelected = (year) => {
    if (!yearFrom && !yearTo) return false;
    return year >= (yearFrom || year) && year <= (yearTo || year);
  };

  return (
    <div>
      <label className="block text-xs font-medium text-text-muted mb-1.5">Год декларации</label>
      <div className="flex flex-wrap gap-1.5">
        {years.map(y => (
          <button
            key={y.year}
            onClick={() => toggleYear(y.year)}
            className={`
              px-2.5 py-1 rounded-md text-xs font-medium transition-colors
              ${isYearSelected(y.year)
                ? 'bg-blue-600 dark:bg-blue-500 text-white'
                : 'bg-app text-text-secondary hover:bg-hover'
              }
            `}
          >
            {y.year}
            <span className="ml-1 opacity-60">({(y.count / 1000000).toFixed(1)}M)</span>
          </button>
        ))}
      </div>
    </div>
  );
}
